// extracted by mini-css-extract-plugin
module.exports = {"ClickButton":"PopForm_ClickButton__a08mD","Header":"PopForm_Header__4MSI9"};